export default __webpack_public_path__ + "static/media/BärbelBas.3944c561.mp4";